export default "__VITE_ASSET__BfuV03Wl__"